import config from '@/config'

const axios = require('axios')

const dataService = {}

dataService.listNationalConfirmed = function() {
  return axios
    .get(config.apiUrl + '/data/national-confirmed')
    .then(res => {
      return { status: res.status, object: res.data }
    })
    .catch(error => {
      console.error(error)
      return { status: 'error' }
    })
}

dataService.listDayInformaction = function(daySelected) {
  return axios
    .get(config.apiUrl + '/data/day-information?date=' + daySelected.date)
    .then(res => {
      return { status: res.status, object: res.data }
    })
    .catch(error => {
      console.error(error)
      return { status: 'error' }
    })
}

export default dataService
